import * as React from "react";
const SvgExpandIconOpen = ({
  title,
  titleId,
  desc,
  descId,
  ...props
}) => <svg {...props} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" aria-labelledby={titleId} aria-describedby={descId}>{desc ? <desc id={descId}>{desc}</desc> : null}{title ? <title id={titleId}>{title}</title> : null}<path d="M14 11L8.17678 5.17678C8.07915 5.07915 7.92085 5.07915 7.82322 5.17678L2 11" stroke="#CCCCCC" strokeWidth={1.33} strokeLinecap="round" /></svg>;
export default SvgExpandIconOpen;